<cms-button
  [text]="language"
  [id]="'language'"
  [btnClass]="[buttonClasses.SecondaryOutline, 'language']"
  (clicked)="changeLanguage()"
></cms-button>
